import { SVGProps } from 'react';

function ArrowRight(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={22}
      aria-label="arrow-right"
      height={20}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.625 10h18.75M11.625 18.75l8.75-8.75-8.75-8.75"
        stroke={props.stroke || 'currentColor'}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

ArrowRight.defaultProps = {
  role: 'graphics-document',
};

export default ArrowRight;
